import { DeliveryState } from "../../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    deliveryId: string;
  };
}

export const removeControlDeliveryByIdDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { deliveryId } = action.payload;
  state.controlDeliveries = state.controlDeliveries.filter(
    (controlDelivery) => controlDelivery.delivery.id !== deliveryId
  );
};
